module.exports = __webpack_public_path__ + "static/Kids_Birthday_Build_My_Book-cf00a1798e8ae793c4abc34d0713116c.jpg";